<template>
	<div>
		<div class="modal fade" id="modalDepartamentos">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title" id="myModalLabel">
							Departamento
						</h4>
					</div>
					<div class="modal-body">
						<div class="col-sm-3">
							<span>Código</span>
							<input
								type="text"
								v-model="data.cod"
								disabled
								class="form-control"
							/>
						</div>

						<div class="col-sm-9">
							<span>Departamento</span>
							<input
								type="text"
								v-model="data.titulo"
								class="form-control"
							/>
						</div>

						<div class="clearfix"></div>
					</div>
					<div class="modal-footer">
						<button
							type="button"
							class="btn btn-default"
							data-dismiss="modal"
						>
							<i class="fa fa-close"></i> Cancelar
						</button>
						<aBtn
							action="private-save-departments"
							@click="saveDep"
							text="Salvar"
							icon="save"
							type="primary"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import aBtn from 'btn';
	import clone from 'js/clone';
	import WBS from 'js/http';
	import toastr from 'toastr';
	let reset = { cod: null, titulo: '' };

	export default {
		name: 'ModalCadastro',
		components: { aBtn },
		data() {
			return {
				data: clone(reset),
			};
		},
		methods: {
			open(data = null) {
				if (data == null) this.data = clone(reset);
				else this.data = clone(data);
				$('#modalDepartamentos').modal('show');
			},
			saveDep() {
				WBS.send('private-save-departments', this.data, (resp) => {
					if (resp.status == 'success') {
						$('#modalDepartamentos').modal('hide');
						toastr.success('Dados salvos com sucesso!');
						this.$emit('updata');
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
					}
				});
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/cadastros/departments/modal.vue